export const SET_PROJECTS = 'SET_PROJECTS';
export const SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT';
export const SET_CURRENT_SERVICE = 'SET_CURRENT_SERVICE';
export const SET_CURRENT_FRONTEND_APP = 'SET_CURRENT_FRONTEND_APP';
export const SET_CURRENT_REDIS_CLUSTER = 'SET_CURRENT_REDIS_CLUSTER';
export const SET_CURRENT_DATABASE = 'SET_CURRENT_DATABASE';
export const ADD_PROJECT = 'ADD_PROJECT';
export const SET_PROJECT = 'SET_PROJECT';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';
export const DELETE_PROJECT = 'DELETE_PROJECT';

// Backend Service Actions
export const ADD_BACKEND_SERVICE = 'ADD_BACKEND_SERVICE';
export const SET_BACKEND_SERVICE = 'SET_BACKEND_SERVICE';
export const UPDATE_BACKEND_SERVICE = 'UPDATE_BACKEND_SERVICE';
export const DELETE_BACKEND_SERVICE = 'DELETE_BACKEND_SERVICE';


// Frontend App Actions
export const ADD_FRONTEND_APP = 'ADD_FRONTEND_APP';
export const SET_FRONTEND_APP = 'SET_FRONTEND_APP';
export const UPDATE_FRONTEND_APP = 'UPDATE_FRONTEND_APP';
export const DELETE_FRONTEND_APP = 'DELETE_FRONTEND_APP';
export const ADD_BRANCH_TO_FRONTEND_APP = 'ADD_BRANCH_TO_FRONTEND_APP';
export const UPDATE_BRANCH_IN_FRONTEND_APP = 'UPDATE_BRANCH_IN_FRONTEND_APP';
export const DELETE_BRANCH_FROM_FRONTEND_APP = 'DELETE_BRANCH_FROM_FRONTEND_APP';
export const UPDATE_FRONTEND_APP_ENVIRONMENT_VARIABLES = 'UPDATE_FRONTEND_APP_ENVIRONMENT_VARIABLES';
export const UPDATE_FRONTEND_APP_BRANCH_ENVIRONMENT_VARIABLES = 'UPDATE_FRONTEND_APP_BRANCH_ENVIRONMENT_VARIABLES';

export const ADD_DATABASE = 'ADD_DATABASE';
export const GET_DATABASE = 'GET_DATABASE';
export const UPDATE_DATABASE = 'UPDATE_DATABASE';
export const DELETE_DATABASE = 'DELETE_DATABASE';

